import { Component, Input } from '@angular/core';

@Component({
  selector: 'dialog-buttons',
  templateUrl: './dialog-buttons.component.html',
  styleUrls: ['./dialog-buttons.component.scss']
})
export class DialogButtonsComponent {

  @Input() submitLabel?: string;
  @Input() submitDisabled = false;
}
